export default class UrlMatchRule {
	checkRule (rule) {
		return this.check(rule.expression_type, rule.expression_value)
	}

	check (expressionType, expressionValue, url = null) {
		if (!url) {
			url = location.href
		}

		switch (expressionType) {
		case '=':
			return this._checkEqual(expressionValue, url)
		case '!=':
			return !this._checkEqual(expressionValue, url)
		case 'contains':
			return this._checkContains(expressionValue, url)
		case '!contains':
			return !this._checkContains(expressionValue, url)
		case 'regExp':
			return this._checkRegExp(expressionValue, url)
		case '!regExp':
			return !this._checkRegExp(expressionValue, url)
		case 'startsWith':
			return this._checkStartsWith(expressionValue, url)
		case '!startsWith':
			return !this._checkStartsWith(expressionValue, url)
		case 'endsWith':
			return this._checkEndsWith(expressionValue, url)
		case '!endsWith':
			return !this._checkEndsWith(expressionValue, url)
		}

		return false
	}

	_checkEqual (expressionValue, url) {
		return expressionValue === url
	}

	_checkContains (expressionValue, url) {
		return url.includes(expressionValue)
	}

	_checkRegExp (expressionValue, url) {
		let regex = new RegExp(expressionValue, 'gmi')
		return regex.test(url)
	}

	_checkStartsWith (expressionValue, url) {
		let regex = new RegExp(`^(${expressionValue})`, 'gmi')
		return regex.test(url)
	}

	_checkEndsWith (expressionValue, url) {
		let regex = new RegExp(`(${expressionValue})$`, 'gmi')
		return regex.test(url)
	}
}



// WEBPACK FOOTER //
// ./src/common/components/Onboarding/RuleChecker/UrlMatchRule.js